var helpers = require('./helpersFunction');

module.exports = function(app) {
	'use strict'
	app.directive('aiModalDir',aiModalDir);
	aiModalDir.$inject=['$rootScope','aiModalService','editorExludeShortcode','stripHtml','$timeout'];
	function aiModalDir($rootScope,aiModalService,editorExludeShortcode,stripHtml,$timeout) {
		return {
			restrict: 'E',
			scope:{
				parent:'=',
                funcionality: '=',
                stripHtml: '=',
                name: '=',
                text: '=',
				onSubmit: '&',
                multiple: '=',
                displayType: '=',   // "block" or "inline"
                displayTypeObj: '=', // "array of objects" or "array of strings"
                editor: '=',
                twoColumns: '=',
                edit: '=',
                diffText: '='
			},      
			replace:true,
			template: require('./partial/aiModal.html'),
			link: function(scope, ele, $attrs, ctrl) {
                $rootScope.modalShow = true;
                scope.loading = true;
                scope.text = scope.text.replace(/[\r\n]+/g, '').replace(/\<br\s*\/?\>/g, '');
                var postData = {};
                var errorTimeoutPromise;
                function errorTimeout(message) {
                    errorTimeoutPromise = $timeout(function() {
                        scope.loading = false;
                        scope.tryAgain = true;
                        scope.errorMessage = message || 'Something went wrong, please try again.';
                    }, 100)
                }
                // Initialize selection is object because to can change the value from child directive
                if (scope.multiple) {
                    scope.selectedSuggestion = {value: []};
                } else {
                    scope.selectedSuggestion = {value: null};
                }
                // Initialize selection
                if(scope.stripHtml == 'all') {
                    // First remove shortcodes, then strip HTML tags
                    var text = stripHtml(editorExludeShortcode(scope.text,true));
                    var postData = {
                        text: text
                    }
                } else if(scope.stripHtml == 'replace-shortcodes') {
                    var postData = {
                        text: helpers.replaceShortcodesWithPlaceholders(scope.text)
                    }
                }
                if(!scope.edit) {
                    aiModalService.get('variables/' + scope.funcionality, function(data) {
                        if(data.variables && data.variables.length > 0) {
                            data.variables.forEach(function(variable) {
                            if(variable == 'keyword') {
                                helpers.addKeywordToPostData(scope.parent.dataPost.keywords, postData)
                            } else if(variable == 'keywords') {
                                helpers.addKeywordsToPostData(scope.parent.dataPost.keywords, postData)
                            }
                        });
                    }
                        postAiHandler()
                    }, function(message) {
                        postAiHandler()
                    });
                } else {
                    scope.loading = false;
                    if(scope.funcionality == 'text-summary') {
                        // Extract content between [summary] tags
                        var summaryMatch = scope.text.match(/\[summary\]([\s\S]*?)\[\/summary\]/);
                        if (summaryMatch && summaryMatch[1]) {
                            // Split by |*| and trim each fact
                            scope.resultFromAi = summaryMatch[1].split('|*|').map(function(fact) {
                                return fact.trim();
                            });
                        } else {
                            scope.resultFromAi = [];
                        }
                    }
                }
                function postAiHandler() { 
                    aiModalService.post(scope.funcionality, postData, function(data) {
                        if(!data.results || data.results.length == 0 || !data.request_id) {
                            errorTimeout();
                        }
                        // Restore shortcodes in the AI results if we have mappings
                        if (scope.stripHtml == 'replace-shortcodes') {
                            scope.resultFromAi = helpers.restoreShortcodes(data.results)
                        } else {
                            scope.resultFromAi = data.results;
                        }
                        scope.request_id = data.request_id;
                        scope.loading = false;
                    }, function(message) {
                        errorTimeout(message);
                    });
                }
                var cancelAiModalFunction = function() {
                    $rootScope.modalShow = false;
                    scope.parent.showAiModal = null;
                    scope.parent.aiToolsObj = null;
                }
                scope.cancelAiModal = function() {
                    cancelAiModalFunction();
                    if(!scope.edit) {
                        if(scope.request_id) {
                            aiModalService.post('feedback', {
                                request_id: scope.request_id,
                                feedback: 0
                            });
                        }
                    }
                }
                scope.applyAiHandler = function() {
                    cancelAiModalFunction();
                    if(!scope.edit) {
                        if(scope.request_id) {
                            aiModalService.post('feedback', {
                                request_id: scope.request_id,
                                feedback: 1
                            });
                        }
                    }
                    scope.onSubmit({funcionality: scope.funcionality, selectedSuggestion: scope.selectedSuggestion.value});
                }
                scope.tryAgainHandler = function() {
                    scope.loading = true;
                    scope.tryAgain = false;
                    scope.errorMessage = null;
                    postAiHandler()
                }
                
				// Add scope cleanup
				scope.$on('$destroy', function() {
					if (errorTimeoutPromise) {
						$timeout.cancel(errorTimeoutPromise);
					}
					$rootScope.modalShow = false;
				});
			}       
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/AIModal/aiModalDirective.js
// module id = 428
// module chunks = 0